import { useEffect } from "react";

const AiPlayer = () => {
  useEffect(() => {
    // Load the external script dynamically
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src = "//vhss.oddcast.com/ai_embed_functions_v1.php";
    document.body.appendChild(script1);

    // Load the AI embed function after the script is loaded
    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.innerHTML = "AI_vhost_embed(800,600,3432155,198,1,1);";
      document.body.appendChild(script2);
    };

    return () => {
      // Cleanup by removing scripts when the component unmounts
      document.body.removeChild(script1);
    };
  }, []);

  return <div id="vhss_aiPlayer"></div>;
};

export default AiPlayer;
